module.exports = __webpack_public_path__ + "static/media/web-based-real1.e2051f92.png";